export default {
  selectedBusinessAddress: {
    businessAddress: {},
    keywords: []
  },
  businessAddresses: [],
  loading: false
};
